import '.e4{font-size:1.125rem;}.ssr-plugin'
import '.eg{line-height:1.75rem;}.ssr-plugin'
import '.bx{text-decoration:none;}.ssr-plugin'
import '.hj{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="e4 eg"
    >
      {translations.privacySubtitle}{' '}
      <a className="bx hj"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="bx hj"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
